import { render, staticRenderFns } from "./BaseHover.vue?vue&type=template&id=231b93da&"
import script from "./BaseHover.vue?vue&type=script&lang=js&"
export * from "./BaseHover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports